import { render, staticRenderFns } from "./AppScrollbar.vue?vue&type=template&id=5feb71ec&scoped=true"
import script from "./AppScrollbar.vue?vue&type=script&lang=js"
export * from "./AppScrollbar.vue?vue&type=script&lang=js"
import style0 from "./AppScrollbar.vue?vue&type=style&index=0&id=5feb71ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5feb71ec",
  null
  
)

export default component.exports